import React, { useEffect, useRef } from "react";

// Animated drifting candlestick background (amber bulls / red bears)
const CandleCanvas = () => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let w, h, raf;
    const CW = 36; // candle spacing
    let candles = [];
    let offset = 0;
    let last = 0;

    const makeCandle = (prevClose) => {
      const drift = 0.35;
      const move = (Math.random() - 0.5 + drift * 0.18) * 46;
      const open = prevClose;
      const close = open + move;
      const high = Math.max(open, close) + Math.random() * 40;
      const low = Math.min(open, close) - Math.random() * 40;
      return { open, close, high, low };
    };

    const seed = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
      const n = Math.ceil(w / CW) + 3;
      candles = [];
      let p = 0;
      for (let i = 0; i < n; i++) { const c = makeCandle(p); candles.push(c); p = c.close; }
    };

    const draw = (t) => {
      const dt = last ? t - last : 16;
      last = t;
      offset += dt * 0.012;
      if (offset >= CW) {
        offset -= CW;
        candles.shift();
        candles.push(makeCandle(candles[candles.length - 1].close));
      }
      ctx.clearRect(0, 0, w, h);

      // grid lines
      ctx.strokeStyle = "rgba(255,176,32,0.035)";
      ctx.lineWidth = 1;
      for (let y = h * 0.1; y < h; y += h / 6) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke(); }

      // normalise to viewport: trend runs bottom-left -> top-right
      let min = Infinity, max = -Infinity;
      candles.forEach((c) => { min = Math.min(min, c.low); max = Math.max(max, c.high); });
      const range = max - min || 1;
      const top = h * 0.08, bot = h * 0.82;
      const y = (v) => bot - ((v - min) / range) * (bot - top);

      candles.forEach((c, i) => {
        const x = i * CW - offset;
        const bull = c.close >= c.open;
        const col = bull ? "255,176,32" : "255,69,96";
        const a = 0.18 + (i / candles.length) * 0.32;
        ctx.strokeStyle = `rgba(${col},${a})`;
        ctx.beginPath(); ctx.moveTo(x + 12, y(c.high)); ctx.lineTo(x + 12, y(c.low)); ctx.stroke();
        const yt = y(Math.max(c.open, c.close));
        const bh = Math.max(2, Math.abs(y(c.open) - y(c.close)));
        ctx.fillStyle = `rgba(${col},${a * 0.9})`;
        ctx.fillRect(x + 1, yt, 22, bh);
        ctx.strokeStyle = `rgba(${col},${Math.min(1, a + 0.15)})`;
        ctx.strokeRect(x + 1.5, yt + 0.5, 21, bh - 1);
      });
      raf = requestAnimationFrame(draw);
    };

    seed();
    raf = requestAnimationFrame(draw);
    window.addEventListener("resize", seed);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", seed); };
  }, []);

  return <canvas ref={ref} id="bgCandles" aria-hidden="true" />;
};

export default CandleCanvas;
